import { administratorRoles } from "../config/roles";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/season";

/**
 * The seasons list. Paged by the search endpoint, the only read the warehouse offers,
 * and read on arrival as the legacy table did. The table has no state column.
 */
export const seasonsListDefinition: ListDefinition = {
  path: "/seasons",
  entityName: "dwseason",
  recordRoute,
  title: "Seasons",
  allowedRoles: administratorRoles,
  data: "search-paged",
  searchOnLoad: true,
  // Lower case: the repository reads this key from a case-sensitive dictionary.
  filters: [{ name: "name", label: "Name", kind: "text", width: "wide" }],
  filterByStatus: false,
  allowAdd: true,
  addRoles: administratorRoles,
  allowStatusEdit: false,
  allowDelete: true,
  deleteRoles: administratorRoles,
  columns: [
    {
      key: "Name",
      label: "Name",
      width: 300,
      sortable: true,
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    {
      key: "seasonstart",
      label: "Start",
      width: 200,
      display: "date",
      sortable: true,
    },
    {
      key: "seasonend",
      label: "End",
      width: 200,
      display: "date",
      sortable: true,
    },
    {
      key: "islastseason",
      label: "Is Last Season",
      width: 200,
      display: "yesno-badge",
      sortable: true,
    },
    {
      key: "isthisseason",
      label: "Is This Season",
      width: 200,
      display: "yesno-badge",
      sortable: true,
    },
    {
      key: "isnextseason",
      label: "Is Next Season",
      width: 200,
      display: "yesno-badge",
      sortable: true,
    },
    {
      key: "createdon",
      label: "Created On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "modifiedon",
      label: "Modified On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
  ],
};
